

export enum WizardStepStatus {

    Waiting = "wait",
    InProgress = "process",
    Completed = "finish",
    Error = "error"

}